import "../styles/index.scss";
import Bulmatown from "bulmatown";

console.info("Site is loaded!");
